<div class="calibration container-fluid" *ngIf="!calibrationActive && !isEng">
    <section class="container-fluid calibration">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3>Калібрування тесту</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-5 calibration-info">
                    <div class="calibration-info_item">
                        <div>
            <span class="current">
              01
              <span>калібрування</span>
            </span>
                        </div>
                        <span>30 сек</span>
                    </div>
                    <div class="calibration-info_item">
                        <div>
            <span>
              02
              <span>eye-tracking тест</span>
            </span>
                        </div>
                        <span>3 хв</span>
                    </div>
                    <div class="calibration-info_item">
                        <div>
            <span>
              03
              <span>звичайний тест</span>
            </span>
                        </div>
                        <span>2-5 хв</span>
                    </div>
                    <div class="calibration-info_item">
                        <div>
            <span>
              04
              <span>результати</span>
            </span>
                        </div>
                        <span>2 хвилини читання</span>
                    </div>
                </div>
                <div class="col-7 calibration-cursor">
                    <div class="row">
                        <div class="col-7">
                            <div class="info">
                                <div class="img_block row">
                                    <div class="col-12">
                                    </div>
                                    <!--                                    <div class="col-6">-->
                                    <!--                                        <img src="../assets/img/calib-img-1.png" alt="calibration"/>-->

                                    <!--                                    </div>-->
                                    <!--                                    <div class="col-6">-->
                                    <!--                                        <img src="../assets/img/calib-img-2.png" alt="calibration"/>-->

                                    <!--                                    </div>-->
                                </div>
                                <div class="calibration-preview">
                                    <div class="dot pulse"></div>
                                    <i class="bi ">
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.21021 7.21094L10.3681 10.3688" stroke="#10082F"
                                                  stroke-width="0.789474" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M6.0626 11.2746L2.34155 2.34302L11.2731 6.06407L8.1203 7.13492L11.0258 10.0404L9.84155 11.0272L7.12644 8.14242L6.0626 11.2746Z"
                                                  fill="white"/>
                                            <path d="M2.34155 2.34302L2.49336 1.97864C2.34571 1.91713 2.17553 1.95079 2.06243 2.0639C1.94933 2.177 1.91566 2.34717 1.97717 2.49482L2.34155 2.34302ZM6.0626 11.2746L5.69823 11.4264C5.76138 11.578 5.91177 11.6746 6.07589 11.6691C6.24001 11.6636 6.38356 11.557 6.43637 11.4015L6.0626 11.2746ZM11.2731 6.06407L11.4001 6.43784C11.5556 6.38503 11.6621 6.24147 11.6676 6.07736C11.6732 5.91324 11.5765 5.76284 11.4249 5.69969L11.2731 6.06407ZM8.1203 7.13492L7.99335 6.76116C7.86419 6.80503 7.76683 6.91247 7.73587 7.04532C7.7049 7.17817 7.74472 7.31759 7.84118 7.41404L8.1203 7.13492ZM11.0258 10.0404L11.2785 10.3436C11.3637 10.2726 11.4151 10.1691 11.4201 10.0583C11.4251 9.94748 11.3833 9.83969 11.3049 9.76126L11.0258 10.0404ZM9.84155 11.0272L9.55411 11.2978C9.69718 11.4498 9.93388 11.4641 10.0943 11.3305L9.84155 11.0272ZM7.12644 8.14242L7.41389 7.87188C7.31894 7.771 7.17806 7.72728 7.04267 7.75668C6.90729 7.78608 6.79723 7.8843 6.75268 8.01547L7.12644 8.14242ZM1.97717 2.49482L5.69823 11.4264L6.42698 11.1228L2.70593 2.19121L1.97717 2.49482ZM11.4249 5.69969L2.49336 1.97864L2.18975 2.7074L11.1213 6.42845L11.4249 5.69969ZM8.24725 7.50869L11.4001 6.43784L11.1462 5.6903L7.99335 6.76116L8.24725 7.50869ZM11.3049 9.76126L8.39942 6.8558L7.84118 7.41404L10.7466 10.3195L11.3049 9.76126ZM10.0943 11.3305L11.2785 10.3436L10.7731 9.73714L9.58885 10.724L10.0943 11.3305ZM6.83899 8.41296L9.55411 11.2978L10.129 10.7567L7.41389 7.87188L6.83899 8.41296ZM6.43637 11.4015L7.50021 8.26937L6.75268 8.01547L5.68884 11.1476L6.43637 11.4015Z"
                                                  fill="#10082F"/>
                                        </svg>

                                    </i>
                                </div>

                                <p>
                                    На екрані випадково з’являтимуться кола.<br>
                                    Наводьте на кола курсором. <br>
                                    Тест автоматично калібрується під ваш курсор.
                                </p>
                                <div class="full-screen-info">
                                    <div class="info-icon">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                                  stroke="#10082F" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <span>Ваш браузер перейде в повноекранний режим для підвищеної точності оцінки.</span>
                                </div>
                            </div>
                            <div class="mt-3 calibration-start">

                                <button class="action-btn hover_action" (click)="onCalibrate($event)">
                                    <span>Продовжити</span>
                                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 13.1328L7 7.13281L1 1.13281" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>

                        </div>
                        <div class="col-5">
                            <div class="warning">
                                <h5>Увага!</h5>
                                <p>Під час тестування використовуються зображення, які можуть викликати негативні емоції.</p>
                                <p>Будьте обережні та натисніть ESC, щоб зупинити тест у будь-який момент без стягнення оплати.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-5"></div>

            </div>
        </div>
    </section>
</div>

<div class="calibration container-fluid" *ngIf="!calibrationActive && isEng">
    <section class="container-fluid calibration">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3>Test Calibration</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-5 calibration-info">
                    <div class="calibration-info_item">
                        <div>
            <span class="current">
              01
              <span>calibration</span>
            </span>
                        </div>
                        <span>30 sec</span>
                    </div>
                    <div class="calibration-info_item">
                        <div>
            <span>
              02
              <span>Eye-tracking test</span>
            </span>
                        </div>
                        <span>3 min</span>
                    </div>
                    <div class="calibration-info_item">
                        <div>
            <span>
              01
              <span>Conventional test</span>
            </span>
                        </div>
                        <span>2-5 min</span>
                    </div>
                    <div class="calibration-info_item">
                        <div>
            <span>
              01
              <span>Results</span>
            </span>
                        </div>
                        <span>a 2 min read</span>
                    </div>
                </div>
                <div class="col-7 calibration-cursor">
                    <div class="row">
                        <div class="col-7">
                            <div class="info">
                                <div class="img_block row">
                                    <div class="col-12">
                                    </div>
                                    <!--                                    <div class="col-6">-->
                                    <!--                                        <img src="../assets/img/calib-img-1.png" alt="calibration"/>-->

                                    <!--                                    </div>-->
                                    <!--                                    <div class="col-6">-->
                                    <!--                                        <img src="../assets/img/calib-img-2.png" alt="calibration"/>-->

                                    <!--                                    </div>-->
                                </div>
                                <div class="calibration-preview">
                                    <div class="dot pulse"></div>
                                    <i class="bi ">
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.21021 7.21094L10.3681 10.3688" stroke="#10082F"
                                                  stroke-width="0.789474" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M6.0626 11.2746L2.34155 2.34302L11.2731 6.06407L8.1203 7.13492L11.0258 10.0404L9.84155 11.0272L7.12644 8.14242L6.0626 11.2746Z"
                                                  fill="white"/>
                                            <path d="M2.34155 2.34302L2.49336 1.97864C2.34571 1.91713 2.17553 1.95079 2.06243 2.0639C1.94933 2.177 1.91566 2.34717 1.97717 2.49482L2.34155 2.34302ZM6.0626 11.2746L5.69823 11.4264C5.76138 11.578 5.91177 11.6746 6.07589 11.6691C6.24001 11.6636 6.38356 11.557 6.43637 11.4015L6.0626 11.2746ZM11.2731 6.06407L11.4001 6.43784C11.5556 6.38503 11.6621 6.24147 11.6676 6.07736C11.6732 5.91324 11.5765 5.76284 11.4249 5.69969L11.2731 6.06407ZM8.1203 7.13492L7.99335 6.76116C7.86419 6.80503 7.76683 6.91247 7.73587 7.04532C7.7049 7.17817 7.74472 7.31759 7.84118 7.41404L8.1203 7.13492ZM11.0258 10.0404L11.2785 10.3436C11.3637 10.2726 11.4151 10.1691 11.4201 10.0583C11.4251 9.94748 11.3833 9.83969 11.3049 9.76126L11.0258 10.0404ZM9.84155 11.0272L9.55411 11.2978C9.69718 11.4498 9.93388 11.4641 10.0943 11.3305L9.84155 11.0272ZM7.12644 8.14242L7.41389 7.87188C7.31894 7.771 7.17806 7.72728 7.04267 7.75668C6.90729 7.78608 6.79723 7.8843 6.75268 8.01547L7.12644 8.14242ZM1.97717 2.49482L5.69823 11.4264L6.42698 11.1228L2.70593 2.19121L1.97717 2.49482ZM11.4249 5.69969L2.49336 1.97864L2.18975 2.7074L11.1213 6.42845L11.4249 5.69969ZM8.24725 7.50869L11.4001 6.43784L11.1462 5.6903L7.99335 6.76116L8.24725 7.50869ZM11.3049 9.76126L8.39942 6.8558L7.84118 7.41404L10.7466 10.3195L11.3049 9.76126ZM10.0943 11.3305L11.2785 10.3436L10.7731 9.73714L9.58885 10.724L10.0943 11.3305ZM6.83899 8.41296L9.55411 11.2978L10.129 10.7567L7.41389 7.87188L6.83899 8.41296ZM6.43637 11.4015L7.50021 8.26937L6.75268 8.01547L5.68884 11.1476L6.43637 11.4015Z"
                                                  fill="#10082F"/>
                                        </svg>

                                    </i></div>

                                <p>
                                    Circles will appear at random on the screen.<br>
                                    Your task is to point at the circles using your mouse/cursor.<br>
                                    The test will automatically calibrate with your cursor.
                                </p>
                                <div class="full-screen-info">
                                    <div class="info-icon">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                                  stroke="#10082F" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <span>Your browser will switch to full-screen mode for enhanced assessment accuracy.</span>
                                </div>
                            </div>

                        </div>
                        <div class="col-5">
                            <div class="warning">
                                <h5>Warning!</h5>
                                <p>The test uses distressing images for assessment.</p>
                                <p>Proceed with caution, and press ESC to stop at any time without charge.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-5"></div>
                <div class="col-7 calibration-start">

                    <button class="hover_action" (click)="onCalibrate($event)">
                        <span>Continue</span>
                        <img src="../assets/img/arrow-next-icon.png" alt="arrow-next-icon">
                    </button>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="calibration-point-wrapper" *ngIf="calibrationActive">
    <lib-grid-calibration (pointOver)="setCalibrationNode($event)"></lib-grid-calibration>
</div>

